module.exports = __webpack_public_path__ + "img/2by2.f8ce15f5.svg";